import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { roleHome } from "../components/ProtectedRoute";
import { Truck, CircleNotch, ArrowLeft } from "@phosphor-icons/react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success(`¡Bienvenido, ${res.user.name}!`);
      navigate(roleHome(res.user.role));
    } else {
      toast.error(res.error);
    }
  };

  const quick = (em) => { setEmail(em); setPassword(em.includes("soycristiano") ? "FletsAdmin2026" : "password123"); };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="relative hidden lg:flex flex-col justify-between p-12 text-white overflow-hidden">
        <img src="https://static.prod-images.emergentagent.com/jobs/56feac90-6b6f-4efe-b6c8-6fff264c6455/images/b8168628452335afc084da399dfc435d6bed1cb3f9a36ca4b7518cf79bab4c70.jpeg"
          alt="Transportista Frets en ruta" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0F1115] via-[#0F1115]/70 to-[#0F1115]/40" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0F1115]/60 to-transparent" />

        <Link to="/" className="relative z-10 flex items-center gap-2">
          <img src="/frets-logo.png" alt="Frets Transporte" className="h-9 w-auto brightness-0 invert" />
        </Link>

        <div className="relative z-10">
          <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-white bg-[#FF5A36] rounded-full px-3.5 py-1.5 mb-6">
            Marketplace de fletes
          </span>
          <h1 className="font-display text-5xl font-black tracking-tighter leading-[1.05]">Tú propones<br />el precio.</h1>
          <p className="mt-4 text-zinc-300 text-lg max-w-sm">Los transportistas acreditados compiten por llevar tu carga.</p>
          <div className="mt-6 flex items-center gap-4">
            <div className="flex -space-x-2">
              {["#FF5A36", "#E04B2A", "#0F1115"].map((c, i) => (
                <span key={i} className="w-9 h-9 rounded-full border-2 border-white/80 flex items-center justify-center text-xs font-bold" style={{ background: c }}>★</span>
              ))}
            </div>
            <span className="text-sm text-zinc-300">+500 servicios completados</span>
          </div>
        </div>

        <span className="relative z-10 text-xs text-zinc-400 uppercase tracking-[0.2em]">Fácil · Rápido · A tu precio</span>
      </div>

      <div className="flex items-center justify-center p-6 sm:p-12 bg-[#F8F9FA]">
        <div className="w-full max-w-md">
          <Link to="/" data-testid="back-to-landing" className="inline-flex items-center gap-1.5 text-sm font-semibold text-zinc-500 hover:text-[#FF5A36] transition-colors mb-6">
            <ArrowLeft size={16} weight="bold" /> Volver al inicio
          </Link>
          <Link to="/" className="lg:hidden flex items-center gap-2 mb-8">
            <img src="/frets-logo.png" alt="Frets Transporte" className="h-9 w-auto" />
          </Link>
          <h2 className="font-display text-3xl font-bold tracking-tight">Ingresa a tu cuenta</h2>
          <p className="text-zinc-600 mt-1 mb-8">Bienvenido de vuelta.</p>

          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <div>
              <label className="text-xs font-bold uppercase tracking-[0.15em] text-zinc-500">Email</label>
              <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="mt-1.5 w-full h-12 px-4 rounded-xl border border-zinc-300 bg-white focus:outline-none focus:ring-2 focus:ring-[#FF5A36] focus:border-transparent" placeholder="tu@email.com" />
            </div>
            <div>
              <label className="text-xs font-bold uppercase tracking-[0.15em] text-zinc-500">Contraseña</label>
              <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="mt-1.5 w-full h-12 px-4 rounded-xl border border-zinc-300 bg-white focus:outline-none focus:ring-2 focus:ring-[#FF5A36] focus:border-transparent" placeholder="••••••••" />
            </div>
            <button data-testid="login-submit" disabled={loading}
              className="w-full h-13 py-3.5 rounded-xl bg-[#FF5A36] text-white font-bold flex items-center justify-center gap-2 hover:bg-[#E04B2A] transition-colors active:scale-95 disabled:opacity-60">
              {loading ? <CircleNotch size={20} className="animate-spin" /> : "Ingresar"}
            </button>
          </form>

          <div className="mt-6 rounded-xl border border-zinc-200 bg-white p-4">
            <p className="text-xs font-bold uppercase tracking-[0.15em] text-zinc-500 mb-2">Cuentas demo</p>
            <div className="flex flex-wrap gap-2">
              <button onClick={() => quick("cliente@flets.cl")} className="text-xs px-3 py-1.5 rounded-full bg-zinc-100 hover:bg-zinc-200 font-medium" data-testid="demo-client">Cliente</button>
              <button onClick={() => quick("transportista@flets.cl")} className="text-xs px-3 py-1.5 rounded-full bg-zinc-100 hover:bg-zinc-200 font-medium" data-testid="demo-carrier">Transportista</button>
              <button onClick={() => quick("soycristianopazo@gmail.com")} className="text-xs px-3 py-1.5 rounded-full bg-zinc-100 hover:bg-zinc-200 font-medium" data-testid="demo-admin">Administrador</button>
            </div>
          </div>

          <p className="mt-6 text-center text-sm text-zinc-600">
            ¿No tienes cuenta? <Link to="/register" className="font-semibold text-[#FF5A36] hover:underline">Regístrate</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
